// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"dbb9ec6c","133":"fdad9b71","443":"fc0a96d3","606":"b83c9bd6","628":"3bed191b","988":"2c96b55a"}[chunkId] + ".chunk.js";
};